var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSllrGreenIconXsmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5005_392920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.3899 3.26491C3.64561 2.31249 4.50892 1.65039 5.49507 1.65039H17.8191C19.2528 1.65039 20.296 3.01067 19.9242 4.39531L16.6101 16.7393C16.3544 17.6917 15.4911 18.3538 14.5049 18.3538H2.18092C0.747247 18.3538 -0.295994 16.9936 0.0757562 15.6089L3.3899 3.26491Z",
    fill: "#123B47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7536 8.00866C10.4379 8.00866 10.2068 8.31891 10.2914 8.62351L11.4414 12.9105C11.4695 13.0233 11.4301 13.108 11.3906 13.1531C11.3512 13.2039 11.2835 13.2659 11.1651 13.2659H5.0601C4.84589 13.2659 4.65423 13.4126 4.59785 13.6213L4.10178 15.4771C4.02286 15.7817 4.24835 16.0807 4.56403 16.0807H11.1651C11.7401 16.0807 12.3208 15.9453 12.7999 15.6294C14.0063 14.834 14.508 13.4633 14.1585 12.1716L13.1381 8.36403C13.0818 8.15532 12.8901 8.00866 12.6759 8.00866H10.7536Z",
    fill: "url(#paint0_linear_5005_392920)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24858 12.0193C9.56426 12.0193 9.79538 11.7147 9.71082 11.4101L8.56084 7.12304C8.53266 7.01023 8.57212 6.92562 8.61158 6.88049C8.65104 6.82972 8.71869 6.76767 8.83707 6.76767H14.9421C15.1563 6.76767 15.348 6.62101 15.4044 6.4123L15.9004 4.55083C15.985 4.24623 15.7539 3.94727 15.4382 3.94727H8.83707C8.26208 3.94727 7.68145 4.08265 7.20229 4.39853C5.99594 5.19389 5.49423 6.5646 5.8381 7.85635L6.85842 11.6639C6.9148 11.8726 7.10646 12.0193 7.32067 12.0193H9.24858Z",
    fill: "url(#paint1_linear_5005_392920)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5005_392920",
    x1: 17.5045,
    y1: 7.1125,
    x2: 3.30363,
    y2: 7.1125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7EE82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EE8E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5005_392920",
    x1: 17.5045,
    y1: 7.1125,
    x2: 3.30363,
    y2: 7.1125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7EE82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EE8E9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5005_392920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSllrGreenIconXsmall);
export default __webpack_public_path__ + "853fdffc2b2c2078fec7699dac5bef0c.svg";
export { ForwardRef as ReactComponent };